module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//3.jpg?c996054129f4d9b3407695794a9806d5";